<template>
  <div v-show="image" class="advert-wrap">
    <a v-on:click="processClick" :href="link">
      <img :src="image">
    </a>
    <p><a class="click" v-on:click="processClick" :href="link">{{ linktext }}</a></p>
  </div>
</template>

<script>
export default {
  name: "AdvertDisplay",
  computed: {


    image: function () {

      if (this.campaign && this.campaign.advert && this.campaign.advert.file) {
        return '/' + this.campaign.advert.file;
      }

      return '';

    },

    link: function () {

      if (this.campaign && this.campaign.advert && this.campaign.advert.link) {
        return this.campaign.advert.link;
      }

      return '#';

    },

    linktext: function () {

      if (this.campaign && this.campaign.advert && this.campaign.advert.link_text) {
        return this.campaign.advert.link_text;
      }

      return '';

    },


  },
  props:
      {
        position: {
          type: String,
          required: true
        }

      },

  data() {
    return {
      campaign: {
        advert:
            {}
      }
    }
  },

  methods: {

    getImage() {

    },

    fetchItems() {

      //this.rand = Math.floor(Math.random() * Math.floor(1000));
      //return;
      axios.get('/ads/display/' + this.position + '.json')
          .then(response => (this.campaign = response.data));

    },

    processClick() {
      axios.get('/ads/click/' + this.campaign.id)
          .then(response => (this.click = response.data))
          .finally();
    },

    create() {
      axios.post(this.endpoint);

      this.active = true;
      this.count++;
    },

    destroy() {
      axios.delete(this.endpoint);

      this.active = false;
      this.count--;
    }
  },

  beforeCreate() {

  },
  created() {
    this.fetchItems();
    setInterval(function () {
      this.fetchItems();
    }.bind(this), 600000);
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  beforeUnmount() {

  },
  unmounted() {

  }


};
</script>

<style scoped>

img {
  max-width: 300px;
}

.advert-wrap {
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
}

.click {
  cursor: pointer;
}
</style>